










import { computed, defineComponent } from "@vue/composition-api";
import { ContentFeedType } from "@scrile/api-provider/dist/projects/scrileConnect/ContentFeedProvider";
import { checkAuthorities } from "@scrile/tools/dist/lib/SecurityHelpers";
import useAuthUser from "@/hooks/useAuthUser";
import emitter from "@/lib/emitter";
import { EVENTS } from "@/const";
import BaseButton from "@/components/BaseButton";
import BaseIcon from "@/components/BaseIcon";

export default defineComponent({
  name: "CreatePostButton",
  components: { BaseButton, BaseIcon },
  props: {
    userId: { type: String, required: true },
    type: { type: String as () => ContentFeedType, default: undefined },
  },
  setup(props) {
    const { authUser, authorities } = useAuthUser();
    const showButton = computed(() => {
      const isAuthor = (authUser.value && authUser.value.id === props.userId) || false;
      return checkAuthorities(authorities.value, isAuthor ? ["createMyContentSet"] : ["createAnyContentSet"]);
    });

    const onClick = () => {
      emitter.emit(EVENTS.SHOW_CREATE_POST, { userId: props.userId, type: props.type });
    };

    return { showButton, onClick };
  },
});
